import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthRepository } from '@app/core/repositories/auth.repository';
import { AppConfig } from '@config/app.config';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiAuthRepository implements AuthRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  logout(): Observable<any> {
    return this.http.post(
      this.appConfig.SERVICES.authentication.sendBackList.url,
      ''
    );
  }
}
